export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--Y.f24fce89.png";